export default __webpack_public_path__ + "static/media/guide_00.351f9580.md";